import Flex from "../../components/Flex";
import Text from "../../components/Text";
import { buildEntryLine, EntrySection } from "../../utils/subjective-entry";
import { ListContent } from "../constant";

/**
 * Prints a Subjective section the way the encounter screen prints it — one
 * numbered line per entry, "Name | Label: Value | ...". Report and visit note
 * read the same EntrySection, so they list the same fields in the same shape.
 *
 * `rows` accepts the raw payload value: the API types these collections as
 * `Set` but sends arrays, and the key may be absent entirely.
 */
const EntryLines = <T,>({
  section,
  rows,
}: {
  section: EntrySection<T>;
  rows?: Iterable<T> | null;
}) => {
  const list = Array.from(rows ?? []);
  if (!list.length) return null;

  return (
    <ListContent
      list={list}
      renderItem={(row, index) => (
        <Flex key={index} gap={0.5}>
          <Text fontWeight={"bold"}>{index + 1}.</Text>
          <Text>{buildEntryLine(section, row)}</Text>
        </Flex>
      )}
    />
  );
};

export default EntryLines;
